module.exports = __webpack_public_path__ + "public/images/slider/davidkina-circle.9d3e38c80afe52781268ed31fac203a5.webp";